import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '../../../../../components';
import css from './SectionHeader.module.css';
import starsIcon from '../../../../../assets/stars.png';

const smartIconMaskStyle = {
  WebkitMaskImage: `url(${starsIcon})`,
  maskImage: `url(${starsIcon})`,
};

const SectionHeader = ({
  title,
  subtitle = null,
  showAvatar = false,
  avatarColor = '#6366f1',
  user = null,
  showSmartIcon = false,
  iconSrc = null,
  iconAlt = '',
  iconAsMask = false,
  iconSize = 26,
  smartIconColor = null,
}) => {
  const iconSizeStyle = { width: iconSize, height: iconSize };
  const iconBgStyle = iconSrc ? { backgroundImage: `url(${iconSrc})`, ...iconSizeStyle } : null;
  const smartIconStyle = {
    ...smartIconMaskStyle,
    ...(smartIconColor ? { backgroundColor: smartIconColor } : {}),
  };
  const getAvatarLetter = () => {
    if (user?.attributes?.profile?.firstName) {
      return user.attributes.profile.firstName.charAt(0);
    }
    return 'U';
  };

  return (
    <div className={css.sectionHeader}>
      <div className={css.sectionTitleContainer}>
        {iconSrc && iconAsMask ? (
          <span className={css.sectionIconBg} style={iconBgStyle} role="img" aria-label={iconAlt} />
        ) : iconSrc ? (
          <SvgIcon
            src={iconSrc}
            alt={iconAlt}
            className={css.sectionIconImage}
            width={iconSize}
            height={iconSize}
          />
        ) : showSmartIcon ? (
          <span
            className={css.smartIcon}
            style={smartIconStyle}
            role="img"
            aria-label="Smart recommendations"
            title="Personalized recommendations based on your preferences"
          />
        ) : null}
        <h2 className={css.sectionTitle}>{title}</h2>
        {showAvatar && (
          <div className={css.sectionAvatar} style={{ backgroundColor: avatarColor }}>
            {getAvatarLetter()}
          </div>
        )}
      </div>
      {subtitle && <p className={css.sectionSubtitle}>{subtitle}</p>}
    </div>
  );
};

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  showAvatar: PropTypes.bool,
  avatarColor: PropTypes.string,
  user: PropTypes.shape({
    attributes: PropTypes.shape({
      profile: PropTypes.shape({
        firstName: PropTypes.string,
      }),
    }),
  }),
  showSmartIcon: PropTypes.bool,
  iconSrc: PropTypes.string,
  iconAlt: PropTypes.string,
  iconAsMask: PropTypes.bool,
  iconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  smartIconColor: PropTypes.string,
};

export default SectionHeader;
